import styles from './modulinformacio.module.scss';
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge/Imatge';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
import clsx from 'clsx';
// @ts-ignore
import { useViewport } from 'hooks/corporatiu/useViewport';
import { ModulInformacioProps, PuntInfoProps } from './ModulInformacio.types';

const PuntInfo = (props: Readonly<PuntInfoProps>) => {
    const { punt } = props;
    return <li className={styles.puntInfo} dangerouslySetInnerHTML={{ __html: punt }}></li>;
};

const ModulInformacio = (props: Readonly<ModulInformacioProps>) => {
    const { titol, subtitol, punts, estil, className, imatge, imatge2, alt, tipus, nota } = props;

    const { isMobile } = useViewport();

    let imatgeSrc = 'https://img.3cat.cat/multimedia/' + imatge;
    let imatgeSrc2 = 'https://img.3cat.cat/multimedia/' + imatge2;

    const stylesWrapper = clsx({
        [styles.wrapperInformacio]: true,
        [styles[estil as string]]: !!estil,
        [className as string]: !!className
    });

    return (
        <div className={styles.modulInformacio}>
            {tipus === 'inici' ? (
                <>
                    {titol && !isMobile && <Titol titol={titol} tag='h2' tipus='gran' />}

                    <div className={stylesWrapper}>
                        <div className={styles.contingutInici}>
                            {titol && isMobile && <Titol titol={titol} tag='h2' tipus='gran' />}
                            {subtitol && <p className={styles.subtitol}>{subtitol}</p>}
                            <ul className={styles.llistaPunts}>
                                {punts.map((punt, index) => (
                                    <PuntInfo key={`3cat-en-viu-punt-info-${index}`} punt={punt} />
                                ))}
                            </ul>
                            {nota && (
                                <>
                                    * <em dangerouslySetInnerHTML={{ __html: nota }}></em>
                                </>
                            )}
                        </div>
                        <div className={styles.imatge}>
                            {imatge && (
                                <Imatge
                                    src={imatgeSrc}
                                    width={1024}
                                    height={576}
                                    alt={alt}
                                    priority={true}
                                    className={styles.foto}
                                />
                            )}
                            {imatge2 && (
                                <Imatge
                                    src={imatgeSrc2}
                                    width={1024}
                                    height={377}
                                    alt={alt}
                                    priority={true}
                                    className={styles.foto}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {titol && <Titol titol={titol} tag='h2' tipus='gran' />}
                    {subtitol && <p className={styles.subtitol}>{subtitol}</p>}
                    <div className={stylesWrapper}>
                        <div className={styles.contingutInici}>
                            <ul className={styles.llistaPunts}>
                                {punts.map((punt, index) => (
                                    <PuntInfo key={`3cat-en-viu-punt-info-${index}`} punt={punt} />
                                ))}
                            </ul>
                        </div>
                        <div className={styles.imatge}>
                            <Imatge
                                src={imatgeSrc}
                                width={1024}
                                height={576}
                                alt={alt}
                                priority={false}
                                className={styles.foto}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ModulInformacio;